import {FullSerial, PartialSerial} from '@app/web-player/serials/serial';

export function assignSerialToEpisodes<T extends FullSerial | PartialSerial>(
  serial: T,
): T {
  if ('episodes' in serial && serial.episodes?.length) {
    serial.episodes = serial.episodes?.map(episode => {
      if (!episode.serial) {
        episode.serial = {...serial};
        delete (episode.serial as FullSerial).episodes;
      }
      return episode;
    });
  }

  return serial;
}
